export default function datepickerWithAddon($sce) {
  'ngInject';

  return {
    restrict: 'AE',
    scope: {
      datepickerWithAddon: '=',
    },
    controller($scope) {
      'ngInject';

      Object.assign(this, $scope.datepickerWithAddon);
      if (this.template && typeof this.template === 'string') {
        this.template = $sce.trustAsHtml(this.template);
      }
    },
  };
}
